import {
    AddCartItem,
    AddToCartError,
    Cart,
    ChangeCartItem,
    UpdateCartItems,
  } from "./shopify-cart.interfaces";
  
  export class ShopifyCartClient {
    private cart?: Cart;
  
    clearCart = async () => {
      const resp = await fetch("/cart/clear");
      if (!resp.ok) {
        throw new Error("Unable to clear cart.");
      }
      return true;
    };
  
    getCart = async (cacheBust = false) => {
      if (this.cart && !cacheBust) {
        return this.cart;
      }
  
      const resp = await fetch("/cart.js", {
        method: "GET",
      });
      const respJSON = await resp.json();
      if (!(resp.status === 200 || resp.status === 201)) {
        throw new Error(
          (respJSON as AddToCartError).message ?? "Unable to get cart."
        );
      }
      this.cart = respJSON as Cart;
      return this.cart;
    };
  
    addItems = async (items: AddCartItem[]) => {
      const body = JSON.stringify({ items });
  
      const resp = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      });
      const respJSON = await resp.json();
      if (!(resp.status === 200 || resp.status === 201)) {
        throw new Error(
          (respJSON as AddToCartError).description ??
            "Unable to add items to cart."
        );
      }
      return respJSON;
    };
  
    updateItems = async (payload: UpdateCartItems) => {
      const body = JSON.stringify(payload);
  
      const resp = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      });
      const respJSON = await resp.json();
      if (!(resp.status === 200 || resp.status === 201)) {
        throw new Error(
          (respJSON as AddToCartError).message ??
            "Unable to update items in cart."
        );
      }
      return respJSON;
    };
  
    changeItem = async (payload: ChangeCartItem) => {
      const body = JSON.stringify(payload);
  
      const resp = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      });
      const respJSON = await resp.json();
      if (!(resp.status === 200 || resp.status === 201)) {
        throw new Error(
          (respJSON as AddToCartError).message ?? "Unable to update cart item."
        );
      }
      return respJSON;
    };


    refreshCart = async () => {
      const cart = await this.getCart(true);
      [...document.querySelectorAll<HTMLElement>("[data-cart-count]")].forEach(
        (ele) => {
          ele.innerHTML = `${cart.item_count}`;
        }
      );
      const cartPreviewEle = document.querySelector("#cart-preview-content");
      if (!cartPreviewEle) return;
      const overflowSuffix = ['- O1', '- O2', '- O3', '- O4', '- O5','- O6','- O7','- O8'];
      const rowTemplate = (
        imageUrl: string,
        productName: string,
        variantTitle: string,
        quantity: number
        // TODO: Fix this HTML
      ) => ` 
        <div class="row my-15">
          <div class="col-3 position-relative">
            <img loading="lazy" class="img-fluid" loading="lazy" src="${imageUrl}">
            <div class="cart-count cart-preview-count vertical-center">
              <span data-cart-count="">${quantity}</span>
            </div>
          </div>
          <div class="col-9 vertical-center">
            <div class="p2">
              ${productName}
            </div>
            <div class="p3">
            ${variantTitle}
          </div>
          </div>
        </div>`;
  
      let rows = cart.items
        .map((item, i) => {
          let title = overflowSuffix.reduce((currentTitle,suffix) => {
            return currentTitle.replace(suffix, '');
          },item.product_title as string);
          let variantTitle = item.variant_title;

          if (!variantTitle || variantTitle.includes('Default Value')) {
            variantTitle = '';
          }
          const row = rowTemplate(item.image, title, variantTitle, item.quantity)
          return row;
        })
        .filter((_, i) => i < 3);
      cartPreviewEle.innerHTML = rows.join("<hr />");
  
      const checkoutButton = document.querySelector('#cart-preview [href="/cart"]');
      checkoutButton?.classList.remove('d-none')

      console.log("Row Num: " + rows.length);
      if (cart.items.length <= 3 ) return;
  
      const moreCart = document.querySelector('.more-cart');
      moreCart?.classList.remove('d-none')
      
      const moreCartCount = document.querySelector("[data-more-cart-count]");
      if(moreCartCount) { 
        const remainingItems = cart.items.length - 3;
        moreCartCount.innerHTML = `${ remainingItems } more item${ remainingItems > 1 ? 's' : '' } in your cart.`
      } 
  
    };

  }
  
  export const shopifyCartClient = new ShopifyCartClient();
  (window as any).shopifyCartClient = shopifyCartClient